import Loadable from 'components/Loadable';

const verifyCertificates = {
  path: '/verify-certificates',
  component: Loadable({
    loader: () => import('../views/promotions/verify-certificates'),
  }),
  routes: [
    {
      exact: true,
      path: '/verify-certificates',
      component: Loadable({
        loader: () => import('../views/promotions/verify-certificates/landing'),
      }),
    },
  ],
};

export default verifyCertificates;
